import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import Icons from '../components/Icons';
import {Button, Col, FormGroup, Input, Row} from 'reactstrap';
import {createItems} from 'tunnel-commande/src/components/cart/CartAction';
import cartStore from 'tunnel-commande/src/components/cart/CartStore';
import {renderLink} from '../utils';
import {Helmet} from 'react-helmet';
import {Product} from '../repositories/product/ProductRepositorySchemas';
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Lazy, Pagination} from 'swiper/core';
import RenderListColors from "../components/Product/RenderListColors";
import Modal from "react-responsive-modal";
import SmallOrderTable from "../components/SmallOrderTable/SmallOrderTable";
import PriceArticle from "../components/SmallOrderTable/PriceArticle";
import Collapse from "@kunukn/react-collapse";
import {HostApiProps, withHostApi} from "../contexts/HostApiContext";
import {Share} from 'react-twitter-widgets';
import Video from "../components/Video";
import { ShopInfoProps } from '../contexts/ShopInfoContext';

SwiperCore.use([Lazy, Pagination]);

interface ProduitInitialPropsResult {
  product: Product,
  colorsClass: any,
  colorId: number,
  categories: any,
  allVideos: any
}

type ProductProps = {context: ProduitInitialPropsResult} & WithTranslation & HostApiProps & {context: ShopInfoProps;};

class Produit extends React.Component<ProductProps, any> {

  private readonly principaleResolution: string;
  private readonly principaleResolutionZoom: string;
  private readonly minatureResolution: string;
  private timeoutId: any;
  private _isMounted: boolean;

  private readonly DTF_ID: number = 488223;

  constructor(props: any) {
    super(props);

    this.timeoutId = null;
    this._isMounted = false;
    this.minatureResolution = '80';
    this.principaleResolution = '770';
    this.principaleResolutionZoom = '1920';

    this.state = {
      withCustomization: true,
      selectedImage: this.getDefaultSelectedImage(props.product, props.colorId),
      prixTotal: 0,
      dateLivraison: null,
      articleData: {},
      openZoom: false,
      openCustomization: false,
      openDeleteCustom: false,
      windowWidth: 0,
      showToastCart: false,
      toastCartMsg: '',
      toastCartQte: 0,
      fadeIn : true,
      products: {},
      enabledAddCart: false,
      selectByUser: false,
      width: 375,
      display: true,
      mobileImgIndexSelected : 0,
      isMobile: false,
      idColor: this.props.context.product?.couleurs[0].id,
      indexColor: 0,
      isTransfertSerigraphique: this.props.context.product.categories_DT?.[0]?.id === 443,
      quantites: {},
      quantityTooltipOpen: false,
      oneSize: this.props.context.product?.couleurs[0]?.tailles.length === 1,
      isOpen : false,
      openVideo: false,
      videoOpenId: ''
    };

    this.handleOnAddCartBtnClick = this.handleOnAddCartBtnClick.bind(this);
    this.handleOnFormChange = this.handleOnFormChange.bind(this);
    this.handleOnColorChange = this.handleOnColorChange.bind(this);
    this.handleOnQtyChange = this.handleOnQtyChange.bind(this);
    this.handleMiniatureListClick = this.handleMiniatureListClick.bind(this);
    this.onOpenModalVideo = this.onOpenModalVideo.bind(this);
    this.onOpenModalZoom = this.onOpenModalZoom.bind(this);

    this.toggleToast = this.toggleToast.bind(this);

  }

  componentWillUnmount(): void {
    cartStore.removeListener('change', this.handleOnCartChange);
    window.removeEventListener("resize", () => { /** */ });
    if (this._isMounted) {
      this.setState({ width: window.innerWidth });
    }
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    cartStore.addListener('change', this.handleOnCartChange);
    window.scroll(0, 0);


    window.addEventListener("resize", () => {
      if (window.innerWidth < 992 && !this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      } else if (window.innerWidth > 992 && this.state.isMobile) {
        this.setState({
          isMobile: false
        });
      }
    });

    if(window.innerWidth < 992 && !this.state.isMobile) {
      this.setState({isMobile: true});
    } else if(window.innerWidth > 992 && this.state.isMobile ) {
      this.setState({isMobile: false});
    }
    if(this.props.context.allVideos && this.state.isTransfertSerigraphique) {
     this.playlistFilter(this.props.i18n.language,['DuckTransfer ACADEMY', 'PageProduit']);
    }
  }

  private handleOnCartChange() {
    if (this._isMounted) {
      this.setState({ cart: cartStore.getCart() });
    }
  }

  private toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  private handleOnPriceChange(data: any) {
    if (this._isMounted && data !== undefined) {
      this.setState({
        prixTotal: data.pt,
        dateLivraison: data.date_livraison
      });
    }
  }

  private getDefaultSelectedImage(product: any, colorId: any, zoom: boolean = false, plaquee: boolean = false) : string {
    let selectedImage: string = '';
    let indexIs =  0;
    const colorIdDefault =  this.props.context.colorId ? this.props.context.colorId : this.props.context.product?.couleurs[0].id;
    if(product && product.couleurs && product.img && colorIdDefault) {
      const colorIdSelected = colorId ? colorId : colorIdDefault;
      const color = product.couleurs.find((elt: any) => elt.id == colorIdSelected);
      //return false;
      const ensembleImg = color.img[this.principaleResolution];
      const ensembleImgZoom = color.img[this.principaleResolutionZoom];
      if(!zoom) {
        selectedImage = ensembleImg && ensembleImg[indexIs] ? ensembleImg[indexIs] : product.img[this.principaleResolution];
      } else {
        if(this.state.mobileImgIndexSelected) {
          indexIs = this.state.mobileImgIndexSelected
        }
        selectedImage = ensembleImgZoom && ensembleImgZoom[indexIs] ? ensembleImgZoom[indexIs] : product.img[this.principaleResolutionZoom];
      }
    } else if(product && product.img) {
      if(!zoom) {
        selectedImage = product.img[this.principaleResolution];
      } else {
        selectedImage = product.img[this.principaleResolutionZoom];
      }
    }

    if (this._isMounted && !zoom) {
      this.setState({ selectedImage: selectedImage });
    }
    if(this._isMounted && typeof this.state.selectedImage !== 'undefined') {
      if(this.state.selectedImage && this.state.selectedImage !== selectedImage) {
        selectedImage = this.state.selectedImage;
      }
    }
    return selectedImage;
  }



  private handleMiniatureListClick(index: any) {
    const img = this.listImg(this.principaleResolution, 'all');
    if (this._isMounted) {
      if (img && img[index]) {
        const videoSelected = img[index].idVideo ? img[index].idVideo : '';
        const imgSeledted = img[index].thumbnail ? img[index].thumbnail : img[index];
        this.setState({ selectedImage: imgSeledted, videoOpenId: videoSelected });
      }
      this.setState({mobileImgIndexSelected : index});
    }
  }

  private toggleToast(qte :any) {
    if(this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    if(qte > 0 && this._isMounted) {
      this.setState({toastCartQte: qte});
      if(qte > 1) {
        this.setState({toastCartMsg: this.props.t('added_articles_message')});
      } else {
        this.setState({toastCartMsg: this.props.t('added_article_message')});
      }
      this.setState({
        showToastCart: true,
        fadeIn: false
      }, () => {
        this.timeoutId = setTimeout(() => {
          this.setState({
            showToastCart: false,
            fadeIn: true
          });
          this.timeoutId = null;
        }, 30000000);
      });
    }
  }


  private playlistFilter(lang: any, tags: any) {
    const playListIdFR = "PLEa8iBAPfwdO066bpDqsEbM0CYBI_SAwx";
    const playListIdEN = "PLEa8iBAPfwdPVYD8uQzzaTMjYimrJ17bi";
    const selectedPlayList = lang && lang == 'fr' ? playListIdFR : playListIdEN;
    if(lang && this.props.context.allVideos?.playlists && this.props.context.allVideos.playlists.length > 0 ) {
      this.props.context.allVideos.playlists.forEach((playlist: any) =>{
        if(playlist.id == selectedPlayList && this.state.videos !== playlist.videos) {
          this.sortByTag(playlist.videos, tags);
        }
      });
    }
  }

  private sortByTag(videos: any, myTags: any) {
    const videosFiltered: any[] =  [];
    videos.map((elt: { snippet: { tags: string[]; }; }) => {
      const hasTags: any[] = [];
      elt.snippet?.tags.map((tag: string) => {
        if (myTags.includes(tag) && !hasTags.includes(tag)) {
          hasTags.push(elt);
        }
      });
      if(hasTags.length == myTags.length && !videosFiltered.includes(elt)) {
        videosFiltered.push(elt);
      }
    });
    this.setState({videos : videosFiltered});
  }

  private handleOnAddCartBtnClick() {
    const items: any[] = [];

    for (const articleId in this.state.quantites) {
      const item: any = {
        article_id: articleId,
        quantite: this.state.quantites[articleId],
        marquage_id: 0,
      };

      items.push(item);
    }
    createItems(items);
    const sumQtes = Object.values(this.state.quantites).reduce((a: any, b: any) => a + b);
    this.setState({ quantiteAjoutee: sumQtes, quantites: {}}, this.onOpenModalCart)
  }

  private listImg(typeResolution: any, index: any)  {
    let images: any = [];
    if(this.props.context.product?.img && this.props.context.product.img[typeResolution]) {

      const img = this.props.context.product?.couleurs?.[this.state.indexColor]?.img;

      if (this.state.indexColor && !Array.isArray(img)) {
        images = [...images, ...img[typeResolution] || []];
      } else if (this.state.idColor && !Array.isArray(img)) {
        images = [...images, ...img[typeResolution] || [], this.props.context.product.img[typeResolution]];
      } else {
        images = [this.props.context.product.img[typeResolution]];
      }
    }

    const listVideoTab = this.state.isTransfertSerigraphique ? this.listVideo() : [];
    images = images.concat(listVideoTab);
    if(index === 'all') {
      return images;
    } else {
      return images[index];
    }
  }

  private listVideo() {
    const videos: any = [];
    if(typeof this.state.videos !== "undefined") {
      if(this.props.context.product?.id && this.props.context.product?.id === 19504){
        return videos;
      }
      this.state.videos.forEach((video: any, index: any) =>{
        const srcVideo = video?.snippet?.thumbnails?.maxres?.url;
        const idVideo = video?.id;
        const titleVideo = video?.snippet?.title;
        if (typeof srcVideo !== 'undefined' && !videos.includes(srcVideo)) {
          const valueToPush: any = {};
          valueToPush.idVideo = idVideo;
          valueToPush.thumbnail = srcVideo;
          valueToPush.titleVideo = titleVideo;
          videos.push(valueToPush);
        }
      });
    }
    return videos;
  }

  private handleOnFormChange(e: any) {
    const target: any = e.target;
    const name: any = target.name;
    const value: any = target.value;
    this.setState({
      ...this.state, [name]: value
    });
  }

  private handleOnQtyChange(e: any = null, isRupture: boolean = false) {
    if(this._isMounted) {
      const tailleDefault = this.props.context.product.couleurs[this.state.indexColor].tailles[0];
      const tailleDefaultRupture = tailleDefault.veille;
      if (e || !tailleDefaultRupture) {
        let value: any = 1;
        let name: any = this.props.context.product.couleurs[this.state.indexColor].tailles[0];
        if (e) {
          const target: any = e.target;
          name = target.name;
          value = target.value;
        }
        const quantites = {...this.state.quantites};
        quantites[name] = parseInt(value);
        let article = this.props.context.product.couleurs[this.state.indexColor].tailles[0];
        if (e) {
          article = this.props.context.product.couleurs[this.state.indexColor].tailles.filter((elt: any) => elt.article_id == name)[0];
        }
        const stockTotal = article.stock_frs + article.stock;
        const taille = article.nom;
        const idArticle = article.article_id;


        if (value > stockTotal && e) {
          this.setState({quantityTooltipOpen: true, stockTotal: stockTotal, taille: taille, quantite: 0, articleData: {}, quantites: 0});
          e.target.value = '';
        } else {
          const properties = {
            quantite: parseInt(value),
            quantites: parseInt(value),
            article_id: idArticle,
          };
          this.setState({
            ...this.state,
            quantites: quantites,
            articleData: properties
          });
        }
      }
    }
  }

  private handleOnColorChange(idColor: number, indexColor: number) {

    this.setState({
      idColor: idColor,
      indexColor: indexColor,
      articleData: {},
      quantite: 0,
      quantites: 0,
    }, () => {
      const selection = document.querySelector('.swiper-container') !== null;
      if (selection) {
          const swiperElt = (document.querySelector('.swiper-container') as any)?.swiper ;
          swiperElt.slideTo(0, 1), this.handleMiniatureListClick(0)
      }
    });
  }

  onOpenModalZoom = (e: any) => {
    if (this._isMounted) { this.setState({openZoom: true, videoOpenId: ''}); }
  }

  onCloseModalZoom = () => {
    if (this._isMounted) { this.setState({openZoom: false}); }
  }

  onOpenModalCart = () => {
    if (this._isMounted) { this.setState({openAddCartModal: true}); }
  }

  onCloseModalCart = () => {
    if (this._isMounted) { this.setState({openAddCartModal: false}); }
  }

  onSlideChanged = (e: any) => {
    if (this._isMounted && e) {
      this.handleMiniatureListClick(e.activeIndex);
    }
  }

  private onCloseQuantityModal = () => {
    this.setState({ quantityTooltipOpen: false, stockTotal: null, taille: null });
  }

  private recupererPdf = () => {
    return this.props.hostApi + this.props.context.product.documentation;
  }

  onOpenModalVideo = (e: any,videoId: any) => {
    if (!this.state.openVideo) { this.setState({openVideo: true}); }
  }
  onCloseModalVideo = () => {
    if (this.state.openVideo) { this.setState({openVideo: false}); }
  }

  render() {
    const isDispo = this.props.context.product?.en_catalogue == true && this.props.context.product.stock_global > 0;

    const renderArianne = () => {
      const category = this.props.context.categories.find((categorie: any) => categorie.IdCategorie == this.props.context.product.categories_DT?.[0]?.id);
      const categoryName = category?.name[this.props.i18n.language];
      const categoryUriArr = category?.links[this.props.i18n.language].split('/');
      const categoryUri = categoryUriArr?.[categoryUriArr.length - 1].split('-').slice(1).join('-');
      return (
        <Row className="m-0 dark-grey arianne pt-0 pt-lg-0  px-3">
          <h5 className="font15 d-flex align-items-center m-0 ">
            {renderLink(`/${this.props.i18n.language}/`, '', '', 'home')}
            {this.props.context.product.categories_DT && this.props.context.product.categories_DT?.length > 0 &&
            renderLink(`/${this.props.i18n.language}/c-${categoryUri}`, categoryName, `/categories?category=${categoryUri}`, 'arrow_dt')
            }
            <span style={{margin: "5px 0"}}><Icons icon={'arrow_dt'} size={10} className="mr-1 ml-1 text-lowercase"/>{titleProduct()}</span>
          </h5>
        </Row>
      );
    };

    const titleProduct = () => {
      let titleProduct =  this.props.context.product.shop?.DT?.titres[this.props.i18n.language] ? this.props.context.product.shop.DT.titres[this.props.i18n.language] : this.props.context.product.titre;
      if(titleProduct == "Mon titre FR" || titleProduct == "My English Title" ) {
        titleProduct = this.props.context.product.titre ;
      }
      return titleProduct ;
    }

    const renderTitle = () => {
      const title = titleProduct() ;
      return <h1 className="robottoLight mb-1">{title}</h1>;
    };

    const renderDescription = () => {
      let texte = this.props.context.product.shop.DT?.descriptions[this.props.i18n.language] || this.props.context.product.description;
      const buttonTxt = this.state.isOpen ? this.props.t('less') : this.props.t('see_more');
      if(texte == "Ma description FR" || texte == "My English Description" ) {
        texte = this.props.context.product.description ;
      }

      const textLength = texte.length;
      let maxHeightDesc = this.state.isMobile ? '3rem' : '4.5rem';
      let showBtn = true;
      if(textLength < 200 || this.state.isTransfertSerigraphique) {
        maxHeightDesc = '100%';
        showBtn = false;
      }

      const pdf = this.recupererPdf();

      return (
        <div className={'descProduct mt-1 mb-4'}>
          {showBtn ?  (
            <Collapse isOpen={this.state.isOpen} collapseHeight={maxHeightDesc}
                      className={"font14 collapse-css-transition collapse-css-transition--gradient " + (this.state.isOpen ? "collapse-css-transition--active" : "")}>
              <p className="font16 robottoRegular" style={{whiteSpace: 'pre-line'}}>{texte}</p>
            </Collapse>
            ) : (
              <p className="font16 robottoRegular" style={{whiteSpace: 'pre-line'}}>{texte}</p>
            )}
          <div className={'d-flex justify-content-end mb-2'}>
            {showBtn &&
            <button className={'bg-transparent border-0 text-underline p-0  mt-2'} id={'showCategoryDesc'}
                    onClick={this.toggle.bind(this)}>{buttonTxt}</button>
            }
          </div>
          <div className={'d-flex align-items-center justify-content-between'}>
            {this.props.context.product.documentation &&
            <a className="font16" href={pdf}
               target="_blank" title="Fiche pdf" rel="noopener noreferrer" >
              <Icons icon="ic-pdf" size={25} className={'red pr-1'}/>Documentation pdf</a>}
          </div>
        </div>
      );
    };


    const renderHead = () => {
      let title = this.props.context.product.shop?.DT?.titres[this.props.i18n.language] ? this.props.context.product.shop.DT.titres[this.props.i18n.language] : this.props.context.product.titre;
      title = this.props.context.product.shop?.DT?.title_tag[this.props.i18n.language] ? this.props.context.product.shop.DT.title_tag[this.props.i18n.language] : title;
      if(title == "Mon titre FR" || title == "My English Title" ) {
        title = this.props.context.product.titre ;
      }
      const link = this.props.context.product.shop?.DT?.links?.[this.props.i18n.language] ? this.props.context.product.shop.DT.links[this.props.i18n.language] : '';
      const linkFR = this.props.context.product.shop?.DT?.links?.['fr'] ? this.props.context.product.shop.DT.links['fr'] : '';
      const linkEN = this.props.context.product.shop?.DT?.links?.['en'] ? this.props.context.product.shop.DT.links['en'] : '';
      const description = this.props.context.product.shop?.DT?.description_tag[this.props.i18n.language] ?  this.props.context.product.shop?.DT?.description_tag[this.props.i18n.language] : this.props.context.product.description ? this.props.context.product.description : '';

      return (
        <>
        <Helmet>
          <title>{title}</title>
          <meta name="twitter:card" content="summary"/>
          <meta name="twitter:site" content="@DuckTransfer"/>
        </Helmet>

        {this.props.context.product && link != '' && title &&  description &&
          <Helmet>
            <meta property="og:site_name" content="DuckTranfer" />
            <meta property="og:locale" content={this.props.i18n.language + '_' + this.props.i18n.language.toUpperCase()} />
            <meta property="og:title" content={title} />
            <meta property="twitter:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="twitter:description" content={description} />
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
          </Helmet>
          }

          {this.state.selectedImage ? (
            <Helmet>
              <meta property="og:image" content={this.state.selectedImage} />
              <meta property="twitter:image" content={this.state.selectedImage} />
              <link rel="preload" href={this.state.selectedImage} as='image'/>
            </Helmet>
          ) :(
            <Helmet>
              <meta property="og:image" content={this.props.context.product.img[this.principaleResolutionZoom]} />
              <meta property="twitter:image" content={this.props.context.product.img[this.principaleResolutionZoom]} />
              <link rel="preload" href={this.props.context.product.img[this.principaleResolutionZoom]} as='image'/>
            </Helmet>
          )}

          {link &&
            <Helmet>
              <meta property="og:url" content={link} />
              <link rel="canonical" href={link}/>
              <link rel="alternate" href={linkFR} hrefLang="x-default"/>
              <link rel="alternate" href={linkFR} hrefLang="fr"/>
              <link rel="alternate" href={linkEN} hrefLang="en"/>
            </Helmet>
          }
        </>
      );
    }

    const renderQuantityModal = () => {
      return (
        <Modal open={this.state.quantityTooltipOpen} onClose={this.onCloseQuantityModal} classNames={{modal: 'customizationModal p-3'}} center>
          <div className="p-2 tooltipQuantite">
            <p className="robottoBold mb-1 d-flex align-items-center mb-4 justify-content-center">
              <Icons icon={'warning'} size={20} fill={"red"} className="mr-1" />
              {this.props.t('only')} {this.state.stockTotal} {this.props.t('items')} {this.props.t('in_size')} {this.state.taille} {this.props.t('are_available')}
            </p>
            {<div className="d-flex justify-content-center">
              <button className="robottoBold rounded-pill buttonThird py-2 px-4"
                      onClick={() => this.onCloseQuantityModal()}>{this.props.t('cancel')}</button>
            </div>}
          </div>
        </Modal>
      );
    };

    const renderAjoutPanier = () => {
      return (
        <div className={'d-flex flex-column'}>
          <FormGroup className={'text-center d-flex m-0 p-0'}>
            {isDispo && this.state.articleData && this.state.articleData.quantites > 0 ? (
              <Button onClick={this.handleOnAddCartBtnClick} className={"w-100 btn px-4 btn-dt-primary borderNone"}>{this.props.t('add_to_cart')}</Button>
            ) : (
              <Button disabled className={"w-100 btn px-4 btn-dt-primary borderNone"}>{this.props.t('add_to_cart')}</Button>
            )}
          </FormGroup>
        </div>
      );
    };

    const renderImage = () => {
      return (
        <Col className="m-0 p-0 text-center">
          {renderImgProduct()}
          {this.state.isTransfertSerigraphique &&
            <div className={"text-left mt-3 pt-3 border-top"}>
              <div className="bold mb-1">{titleProduct()}</div>
            {renderDescription()}
            </div>
          }
        </Col>
      );
    };

    const imgSlider = () => {
      const img = [];

      img.push(imgsMobile);
      return img;
    };

    const renderImgProduct = () => {
      const titre = titleProduct();
      const isMobile = typeof window !== "undefined" ? window.innerWidth < 992 : false;
      const settingsImgProduct: Record<string, any> = {
        slidesPerView: 1,
        loop: false,
        on: {
          activeIndexChange: function (indexNext: any) {
           this.handleMiniatureListClick(indexNext)
          }
        }
      };

      if(isMobile) {
        settingsImgProduct.pagination = {
          "clickable": true,
          "renderBullet": function (i: number, className : any) {
            return '<span class="bullet-mobile ' + className + '" ><img src="/images/circle.svg"  width="20" height="20" alt="' +titre + '"/></span>';
          }
        }
      } else {
        settingsImgProduct.pagination = {
          "clickable": true,
          "renderBullet": function (i: number, className : any) {
            const imgSrc = imgsPagination(i);
            if (imgSrc.thumbnail) {
              return '<span class="bullet-custom position-relative cursor-pointer d-flex flex-column justify-content-center align-items-center position-relative playVideosContainer playVideosContainerMiniatures '+ className +'" style="z-index: 10"> ' +
                '<img src="/images/playIcon.svg" class="white playVideosIcon" height="40px" width="40px" />'+
                '<img src="' + imgSrc.thumbnail + '"  alt="' +titre + '" class="img-fluid cursor-pointer"  /> '+
                '</span>';
            } else {
              return '<span class="bullet-custom ' + className + '" >' +
                '<img  alt="' +titre + '" src=' + imgSrc + ' />' +
                '</span>';
            }
          }
        }
      }

      return (
        <div className=" mb-2 text-center overflow-hidden overflow-hidden-down-md  ">
          <Swiper {...settingsImgProduct} lazy={true} onSlideChange={e => this.onSlideChanged(e)} className="swiper-container mobileProduct sliderImgProduct my-4 my-lg-0" key={'mobileProduct-' + this.props.context.product.id}>
            {imgSlider()}
          </Swiper>
        </div>
      );
    };

    const renderZoomImage = () => {
      const zoomImageZoom = this.getDefaultSelectedImage(this.props.context.product, this.props.context.colorId, true, false).toString();

      return (
        <Modal open={this.state.openZoom} onClose={this.onCloseModalZoom} classNames={{modal: "zoomModalContainer"}}
               center>
          <div className="p-2">
            <img src={zoomImageZoom}  alt={titleProduct() || ''} className="img-productCard img-fluid"/>
          </div>
        </Modal>
      );
    };

    const imgsMobile = this.listImg(this.principaleResolution, 'all').map((elt: any, index: any) => {
      const linkImg = elt.thumbnail ? elt.thumbnail : elt;

      return (
        <>
          {elt.thumbnail ? (
            <SwiperSlide key={index} className="position-relative cursor-pointer d-flex flex-column justify-content-center align-items-center position-relative playVideosContainer mb-2" onClick={ (e) => this.onOpenModalVideo(e, elt.idVideo)}  >
              <Icons icon="just_play" className={" white playVideosIcon"} size={120}/>
              <img  data-src={linkImg}  alt={elt.titleVideo} className={"  cursor-pointer img-fluid swiper-lazy "} />
              <div className={'italic'}>{elt.titleVideo}</div>
            </SwiperSlide>
          ) : (
            <SwiperSlide key={index} className="position-relative"  onClick={(e) => this.onOpenModalZoom(e)} >
              {index == 0 ? (
                  <img src={linkImg} alt={titleProduct() || ''} className={"  cursor-pointer img-fluid  "} />
                ) : (
                  <>
                  <img  data-src={linkImg}     alt={titleProduct() || ''}   className={"  cursor-pointer img-fluid swiper-lazy "} />
                  <div className="swiper-lazy-preloader swiper-lazy-preloader-white"></div>
                  </>
                )}
            </SwiperSlide>
          )}
        </>
      );
    });

    const imgsPagination = (i: number) => {
      return this.listImg(this.minatureResolution, i);
    }


    const renderShareSocial = () => {
      const link = this.props.context.product.shop?.DT?.links?.[this.props.i18n.language] ? this.props.context.product.shop.DT.links[this.props.i18n.language] : '';
      //TODO Faire des liens de partage de produit
      return (
        <div className={'flex-grow-1 my-4 d-flex'}>
          <iframe
            src={"https://www.facebook.com/plugins/share_button.php?href="+link+"&layout=button&size=small&width=81&height=20&appId"}
            width="81" height="20" style={{border: 'none',overflow:'hidden'}} scrolling="no" frameBorder="0"
            allowFullScreen
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"></iframe>
          <div className={'ml-2'}>
          <Share url="https://twitter.com/share?ref_src=twsrc%5Etfw" />
          </div>
        </div>
      );
    };
    const inputTailles = this.props.context.product?.couleurs[this.state.indexColor]?.tailles.map((elt: any,index: any) => {
      let nomTaille =  elt.nom;

      if(this.state.oneSize && nomTaille.includes('unique')) {
        nomTaille =  this.props.t('quantity') + ' : ';
        nomTaille =  '';
      }

      const DefaultValue = this.state.articleData?.quantite ? this.state.articleData?.quantite : 0;
      const isRupture = (elt.stock + elt.stock_frs) < 1 ;

      return (
        <div className={` ${this.state.oneSize && nomTaille.includes('unique') ? 'd-flex align-items-center flex-grow-1 justify-content-end ' : 'text-center'}`}  key={index}>
          <span className={'font14 flex-grow-1'}>{nomTaille}</span>
          <Input className={`border-dark input-dt-cmd mr-4 text-center ${this.state.oneSize ? 'ml-4' : ''}`} disabled={isRupture} min={0} value={DefaultValue} max={elt.stock + elt.stock_frs}
                 id={'quantite-' + elt.article_id} name={elt.article_id} onChange={e => this.handleOnQtyChange(e, isRupture)} type={"number"}/>
          {isRupture &&
          <div className={'grey italic pt-1 text-center'}>{this.props.t('sold_out')}</div>
          }
        </div>
      );
    });

    const renderInputQuantity = () => {
      if(this.state.idColor && this.props.context.product?.couleurs[this.state.indexColor]?.tailles) {
        return (
          <div className={`d-flex  ${this.state.oneSize ? 'justify-content-end align-items-end mr-2 flex-grow-1' : ''} `}>
            {this.state.oneSize &&
            <div className={'pb-3'}>{this.props.t('quantity')} : </div>
            }
            <div className={`d-flex  ${this.state.oneSize ? ' align-items-center mr-2 ' : ''} `}>
              {inputTailles}
            </div>
          </div>
        );
      }
    }

    const renderAddCartModal = () => {
      return (
        <Modal open={this.state.openAddCartModal} onClose={this.onCloseModalCart} classNames={{modal: "zoomModalCart"}} center>
          <div className={'p-md-5'}>
            <p className={'bold text-center'}>
              <Icons icon="done" size={26} className={'puce mr-2 green'}/> {this.state.quantiteAjoutee} {this.props.t('items_have_been_added_to_your_cart')}.
            </p>
            <p className={'py-3 text-center'}>{this.props.t('what_do_you_want_to_do')}</p>
            <div className={'d-flex'}>
              <button className={'btn btn-dt-secondary mr-4'} onClick={this.onCloseModalCart}>{this.props.t('continue_shopping')}</button>
              <a href={`/${this.props.i18n.language}/cart`}>
                <button className={'btn btn-dt-primary ml-4 cursor-pointer'} onClick={this.onCloseModalCart} >
                  <Icons icon="cart" size={26} className={`shortIconMenu color mr-2 ml-2 white`}/>
                  {this.props.t('finalize_my_order')}
                </button>
              </a>
            </div>
          </div>
        </Modal>
      );
    }

    const priceFromVierge = this.props.context.product?.a_partir_de_MT_data && this.props.context.product?.a_partir_de_MT_data?.a_partir_de ? this.props.context.product.a_partir_de_MT_data.a_partir_de : this.props.context.product.a_partir_de_DT;
    const classListColors = this.props.context.product.couleurs && this.props.context.product.couleurs.length < 2 ? 'd-block d-lg-flex' : ' d-block ' ;
    const isDTF = this.props.context.product.couleurs[this.state.indexColor].tailles[0].article_id === this.DTF_ID;

    return (
      <>
        {renderHead()}
        <div className={'container-fluid container-fluid-dt p-0 mt-1'}>
          {renderArianne()}
          <div className="product-container m-0 mt-lg-4 mb-lg-4 d-flex flex-column"  id="productContainer">
            <Row className={'m-0 '}>
              <Col xs={12} md={6} xl={6}>
                {renderImage()}
              </Col>
              <Col xs={12} md={6} xl={{size: 6}}>
                {renderTitle()}
                {!this.state.isTransfertSerigraphique &&
                 renderDescription()
                }
                {renderShareSocial()}
                {renderZoomImage()}
                <legend/>
                {!this.state.isTransfertSerigraphique &&
                <div className={" border-top w-100 pt-3 pt-lg-4 justify-content-between align-items-start " + classListColors}>
                  <RenderListColors couleurs={this.props.context.product.couleurs} titleProduct={titleProduct()}
                                    idColorSelected={this.state.idColor} resolutionsMin={this.minatureResolution}
                                    onColorClick={this.handleOnColorChange}/>
                  <div>
                    <FormGroup className={'font20 m-0 d-flex justify-content-end'}>
                      <PriceArticle dispo={isDispo} priceFrom={priceFromVierge} productId={this.props.context.product.id} isTransfert={this.state.isTransfertSerigraphique} lng={this.props.i18n.language}
                                    articleData={this.state.articleData} onPriceChange={this.handleOnPriceChange}/>
                    </FormGroup>
                    <div className={'d-flex justify-content-between my-2 align-items-end flex-wrap'}>
                      {renderInputQuantity()}
                      {renderAjoutPanier()}
                    </div>
                  </div>
                </div>
                }
                {!this.state.isTransfertSerigraphique && renderQuantityModal()}
                {!this.state.isTransfertSerigraphique && renderAddCartModal()}
                {this.state.isTransfertSerigraphique &&  <SmallOrderTable product={this.props.context.product} allVideos={this.props.context.allVideos} surfaceMin={this.props.context.shopInfo.surfaceMin} />}
              </Col>
            </Row>
          </div>
          {this.state.isTransfertSerigraphique && this.props.context.allVideos && !isDTF &&
            <Col xs={12} md={12}>
            <div className={'bold  border-black border-bottom pb-2 mb-4 text-capitalize'}>{this.props.t('video')}</div>
            <Video onlyModale={false} allVideos={this.props.context.allVideos} fullWidth tag={this.props.context.product.titre} />
            </Col>
          }
        </div>
        {this.state.videoOpenId && this.state.videoOpenId != '' &&
        <Modal open={this.state.openVideo} onClose={this.onCloseModalVideo} classNames={{modal: "zoomVideo"}}
               center>
          <div className={"embed-responsive embed-responsive-16by9"}>
            <iframe className={"embed-responsive-item"}
                    src={`https://www.youtube-nocookie.com/embed/${this.state.videoOpenId}?controls=1&autoplay=1&rel=0&showinfo=0&modestbranding=1&iv_load_policy=3`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
          </div>
        </Modal>
        }
      </>
    );
  }
}

export default withTranslation()(withHostApi(Produit));
